import type { ComponentProps } from 'react'
import React from 'react'

import { PageLayout, TabPills } from '@components/common'
import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { SECTION_NAMES } from '@constants/sectionNames'
import { BaseContent, HeadContent } from '@fourthwall/components'

import { ConnectionsGrid } from './components/ConnectionsGrid/ConnectionsGrid'

type AppsViewProps = {
  tabs: ComponentProps<typeof TabPills>
  apps: ComponentProps<typeof ConnectionsGrid>['items']
}

export const AppsView = ({ tabs, apps }: AppsViewProps) => (
  <>
    <HeadContent title={SECTION_NAMES.apps} />
    <PageLayout>
      <Dashboard.Section
        name={SECTION_NAMES.apps}
        title={
          <BaseContent appearance="secondary">
            Elevate your Fourthwall experience with our apps and integrations.
          </BaseContent>
        }
      >
        <div style={{ marginBottom: 24 }}>
          <TabPills {...tabs} />
        </div>
        <ConnectionsGrid items={apps} />
      </Dashboard.Section>
    </PageLayout>
  </>
)
